import { PlumaSnackbarApi } from '@customerio/pluma-components/react';

export const snackbarApi = new PlumaSnackbarApi();

type SnackbarCreateArgs = Parameters<typeof snackbarApi.create>;

// sessionStorage key shared with the Ember app's snackbars service
// (`app/services/snackbars.ts`). Ember-side flows that show a one-time message
// and then hand off to a Hydra-owned route (e.g. confirm-account / reset-password
// redirecting to the migrated login) enqueue the message via `createPersisted`;
// the Ember snackbar container unmounts on handoff, so Hydra replays it here.
const PENDING_KEY = 'cio-pending-snackbars';

/**
 * Re-fires any snackbars the Ember app enqueued via `snackbars.createPersisted`
 * before handing off to a Hydra route, then clears them. Mirrors Ember's
 * `replayPending`, reading the same sessionStorage key and create-args shape.
 * Safe to call repeatedly — the key is cleared before re-firing, so a second
 * call is a no-op.
 */
export function replayPendingSnackbars() {
  let raw: string | null = null;
  try {
    raw = window.sessionStorage.getItem(PENDING_KEY);
    if (raw == null) {
      return;
    }
    window.sessionStorage.removeItem(PENDING_KEY);
  } catch {
    return;
  }
  try {
    const pending = JSON.parse(raw) as SnackbarCreateArgs[];
    for (const args of pending) {
      snackbarApi.create(...args);
    }
  } catch {
    // Malformed payload — already cleared above.
  }
}
